const methods = [
  'filter',
  'updateKeyChildren',
  'getCheckedNodes',
  'setCheckedNodes',
  'getCheckedKeys',
  'setCheckedKeys',
  'setChecked',
  'getHalfCheckedNodes',
  'getHalfCheckedKeys',
  'getCurrentKey',
  'getCurrentNode',
  'setCurrentKey',
  'setCurrentNode',
  'getNode',
  'remove',
  'append',
  'insertBefore',
  'insertAfter'
];
export default {
  name: 'RtTree',
  render(h) {
    return h(
      'el-tree',
      {
        attrs: this.$attrs,
        props: this.$props,
        ref: 'tree'
      },
      this.$slots.default
    );
  },
  mounted() {
    this.$nextTick(() => {
      // 将 elementui tree 组件原生方法附加在 rtTree 上面
      methods.map(method => {
        this[method] = this.$refs.tree[method];
      });
    });
  }
};



// WEBPACK FOOTER //
// ./~/vue-xpc/src/components/tree/rtTree.js